var _polygon, _polygon2, _rect, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconOptionsCentre(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44.24 56.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-options-centre") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "44.24 13.07 38.21 18.1 2.01 18.1 2.01 8.04 38.21 8.04 44.24 13.07",
    fill: "#00d3ff"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "0 31.17 6.03 26.14 42.23 26.14 42.23 36.2 6.03 36.2 0 31.17",
    fill: "#00d3ff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.1,
    width: 4.02,
    height: 18.1,
    fill: "#00d3ff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18.1,
    y: 20.11,
    width: 4.02,
    height: 16.09,
    fill: "#00d3ff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18.1,
    y: 38.21,
    width: 4.02,
    height: 18.1,
    fill: "#00d3ff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOptionsCentre);
export default __webpack_public_path__ + "static/media/icon-options-centre.5c64775d2a3ee6e5e35a12fc43454fb0.svg";
export { ForwardRef as ReactComponent };